import {adminSiteService, blogService} from '../services'

const state = {
    loading: null,
    site: {
        owner: {
            labels: [],
            tiers: [],
        },
    },
    metadata: {
        loading: false,
        labels: [],
    },
}

const actions = {

    get ({ dispatch, commit }, id) {
        commit('getSiteRequest')
        return adminSiteService.get(id).then(
            response => {
                commit('getSiteSuccess', response)
                return response
            },
            error => {
                commit('getSiteError')
                dispatch('alert/error', error, { root: true })
            }
        )
    },
    update ({ dispatch, commit }, params) {
        commit('getSiteRequest')
        adminSiteService.update(params).then(
            response => {
                commit('getSiteSuccess', response)
                dispatch('alert/success', 'Site updated successfully.', { root: true })
            },
            error => {
                commit('getSiteError')
                dispatch('alert/error', error, { root: true })
            }
        )
    },
    loadMetadata ({ dispatch, commit }) {
        commit('loadMetadataRequest')
        return adminSiteService.loadMetadata().then(
            response => {
                commit('loadMetadataSuccess', response)
                return response
            },
            error => {
                commit('loadMetadataError')
                dispatch('alert/error', 'Unable to load site metadata: ' + error, { root: true })
            }
        )
    },
}

const mutations = {
    getSiteRequest (state) {
        state.loading = true
    },
    getSiteSuccess (state, data) {
        state.site = data.site
        state.loading = false
    },
    getSiteError (state) {
        state.loading = false
    },
    loadMetadataRequest(state) {
        state.metadata.loading = true
    },
    loadMetadataSuccess(state, response) {
        state.metadata.loading = false
        state.metadata.labels = response.labels
        state.metadata.tiers = response.tiers
    },
    loadMetadataError(state, response) {
        state.metadata.loading = false
    },
}

const getters = {
    isInit (state) {
        return state.loading === null
    },
    isLoading (state) {
        return state.loading === true
    },
    getSite (state) {
        return state.site
    },
    getMetadataLabels(state) {
        return state.metadata.labels
    },
    getMetadataTiers(state) {
        return state.metadata.tiers
    },
    labels(state, getters) {
        return getters.getMetadataLabels
            .map(f => { return { text: f.name, value: f.id } })
    },
    paidTiers(state, getters) {
        return getters.getMetadataTiers
            .filter(f => f.type === 'paid')
            .map(f => { return { text: f.name, value: f.id } })
    },
}


export const adminSiteModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
